import React from 'react';
import {Sale} from "../Header/Sale";
import televizion from "../../../resources/images/televizion.png";
import alibaba from "./../../../resources/images/alibaba.png"
import carousel from "./../Body/carousel"
import $ from "jquery"
import {Footer} from './footer';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import {Link} from "react-router-dom";

export const Product = () => {

    let settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    return (
        <div className="Product mt-5">
            <div className="container">
                <div className="row m-0">
                    <div className="col-3 px-1">
                        <Link>
                            <img src="https://wp.toko.uz/wp-content/uploads/2020/12/square_1.jpg" alt=""
                                 className="w-100"/>
                        </Link>
                    </div>
                    <div className="col-3 px-1">
                        <Link>
                            <img src="https://wp.toko.uz/wp-content/uploads/2020/12/square_2.jpg" alt=""
                                 className="w-100"/>
                        </Link>
                    </div>
                    <div className="col-3 px-1">
                        <Link>
                            <img src="https://wp.toko.uz/wp-content/uploads/2020/12/square_3.jpg" alt=""
                                 className="w-100"/>
                        </Link>
                    </div>
                    <div className="col-3 px-1">
                        <Link>
                            <img src="https://wp.toko.uz/wp-content/uploads/2020/12/square_4.jpg" alt=""
                                 className="w-100"/>
                        </Link>
                    </div>
                </div>
                <div className="mt-5">
                   <span>
                       <p className="header_p__discount">Товары на скидке</p>
                   </span>
                   <span>
                       <div className="header-block_line mx-3"></div>
                   </span>
                   <span className="header-block_button">
                       <button className="py-1 px-3">Посмотреть все</button>
                   </span>
                </div>
                <div className="row">
                    <div className="col-md-3 pl-0">
                        <Sale
                            ImgUrl="https://wp.toko.uz/wp-content/uploads/2020/10/photo_2020-10-14_17-02-20-300x300.jpg"
                            ProductName="La Lavande"
                            ProductInfo="Гейзер для ванн Мята"
                            NewPrice="376 000 сум"
                            OldPrice="537 000 сум"
                        />
                    </div>
                    <div className="col-md-3 pl-0">
                        <Sale
                            ImgUrl="https://wp.toko.uz/wp-content/uploads/2020/12/6hpt30pj1mz_1984_1-300x300.jpg"
                            ProductName="DI sport"
                            ProductInfo="футболка с дл рукавом - man jersey"
                            NewPrice="376 000 сум"
                            OldPrice="537 000 сум"
                        />
                    </div>
                    <div className="col-md-3 pl-0">
                        <Sale
                            ImgUrl="https://wp.toko.uz/wp-content/uploads/2020/12/ft2513__1-300x300.jpg"
                            ProductName="La Lavande"
                            ProductInfo="Гейзер для ванн Мята"
                            NewPrice="376 000 сум"
                            OldPrice="537 000 сум"
                        />
                    </div>
                    <div className="col-md-3 pl-0">
                        <Sale
                            ImgUrl="https://wp.toko.uz/wp-content/uploads/2020/12/dq1849__1-300x300.jpg"
                            ProductName="La Lavande"
                            ProductInfo="Гейзер для ванн Мята"
                            NewPrice="376 000 сум"
                            OldPrice="537 000 сум"
                        />
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-3 pl-0">
                        <Sale
                            ImgUrl="https://wp.toko.uz/wp-content/uploads/2020/12/cj2055_691_1-300x300.jpg"
                            ProductName="La Lavande"
                            ProductInfo="Гейзер для ванн Мята"
                            NewPrice="376 000 сум"
                            OldPrice="537 000 сум"
                        />
                    </div>
                    <div className="col-md-3 pl-0">
                        <Sale
                            ImgUrl="https://wp.toko.uz/wp-content/uploads/2020/11/53_g051sz003.000.574549.vr059.6.50-300x300.jpg"
                            ProductName="La Lavande"
                            ProductInfo="Гейзер для ванн Мята"
                            NewPrice="376 000 сум"
                            OldPrice="537 000 сум"
                        />
                    </div>
                    <div className="col-md-3 pl-0">
                        <Sale
                            ImgUrl="https://wp.toko.uz/wp-content/uploads/2020/10/44bacedc2082a15d9f663c2864c9d57d-300x300.jpg"
                            ProductName="La Lavande"
                            ProductInfo="Гейзер для ванн Мята"
                            NewPrice="376 000 сум"
                            OldPrice="537 000 сум"
                        />
                    </div>
                    <div className="col-md-3 pl-0">
                        <Sale
                            ImgUrl="https://wp.toko.uz/wp-content/uploads/2020/10/3bebda7408c41b33f16aea1d8e1166d1-300x300.jpg"
                            ProductName="La Lavande"
                            ProductInfo="Гейзер для ванн Мята"
                            NewPrice="376 000 сум"
                            OldPrice="537 000 сум"
                        />
                    </div>
                </div>
            </div>
            <div className="container header-brands mb-5">
                <div>
                   <span>
                       <p className="header_p__discount">Магазины</p>
                   </span>
                    <span>
                       <div className="header-block_line header-block_Secondline mx-3"></div>
                   </span>
                    <span className="header-block_button">
                       <button className="py-1 px-3">Все магазины</button>
                   </span>
                </div>
                <div className="header-brands__brandName carousel slide carousel-inner" id="myCarousel"
                     data-ride="carousel">
                    <Slider {...settings}>
                        <div className="carousel-item">
                            <div className="row text-center owl-carousel owl-theme" id="owl-demo">
                                <div className="col-md-2 item">
                                    <img src={alibaba} alt=""/>
                                </div>
                                <div className="col-md-2 item">
                                    <img src={alibaba} alt=""/>
                                </div>
                                <div className="col-md-2 item">
                                    <img src={alibaba} alt=""/>
                                </div>
                                <div className="col-md-2 item">
                                    <img src={alibaba} alt=""/>
                                </div>
                                <div className="col-md-2 item">
                                    <img src={alibaba} alt=""/>
                                </div>
                                <div className="col-md-2 item">
                                    <img src={alibaba} alt=""/>
                                </div>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <div className="row text-center owl-carousel owl-theme" id="owl-demo">
                                <div className="col-md-2 item">
                                    <img src={alibaba} alt=""/>
                                </div>
                                <div className="col-md-2 item">
                                    <img src={alibaba} alt=""/>
                                </div>
                                <div className="col-md-2 item">
                                    <img src={alibaba} alt=""/>
                                </div>
                                <div className="col-md-2 item">
                                    <img src={alibaba} alt=""/>
                                </div>
                                <div className="col-md-2 item">
                                    <img src={alibaba} alt=""/>
                                </div>
                                <div className="col-md-2 item">
                                    <img src={alibaba} alt=""/>
                                </div>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <div className="row text-center owl-carousel owl-theme" id="owl-demo">
                                <div className="col-md-2 item">
                                    <img src={alibaba} alt=""/>
                                </div>
                                <div className="col-md-2 item">
                                    <img src={alibaba} alt=""/>
                                </div>
                                <div className="col-md-2 item">
                                    <img src={alibaba} alt=""/>
                                </div>
                                <div className="col-md-2 item">
                                    <img src={alibaba} alt=""/>
                                </div>
                                <div className="col-md-2 item">
                                    <img src={alibaba} alt=""/>
                                </div>
                                <div className="col-md-2 item">
                                    <img src={alibaba} alt=""/>
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>
                <div className="row m-0 mt-5">
                    <div className="col-3 px-0">
                        <Link>
                            <img src="https://wp.toko.uz/wp-content/uploads/2020/12/square_1.jpg" alt=""
                                 className="w-100"/>
                        </Link>
                    </div>
                    <div className="col-3 px-0">
                        <Link>
                            <img src="https://wp.toko.uz/wp-content/uploads/2020/12/square_2.jpg" alt=""
                                 className="w-100"/>
                        </Link>
                    </div>
                    <div className="col-3 px-0">
                        <Link>
                            <img src="https://wp.toko.uz/wp-content/uploads/2020/12/square_3.jpg" alt=""
                                 className="w-100"/>
                        </Link>
                    </div>
                    <div className="col-3 px-0">
                        <Link>
                            <img src="https://wp.toko.uz/wp-content/uploads/2020/12/square_4.jpg" alt=""
                                 className="w-100"/>
                        </Link>
                    </div>
                </div>
            </div>
            <div>
            </div>
            <Footer/>
        </div>
    )
}